import {tgxApi} from "../../app/tgxApi";
import {serialize} from "../../helpers/utils/Utils";
import {getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess} from "../../helpers/utils/RtkQueryUtils";

export const branchContactApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        branchContacts: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/branch-contacts/by-branch?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['branchContacts'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getBranchContactById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-branch-contacts/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags:["contactByBranchId"],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBranchContactByContactId: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-branch-contact/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
            },
        }),

        getBranchByCustomerId: build.query({
            query: (customerId) => {
                return {
                    url: `/ajax/get-branch-by-customer-id/${customerId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createBranchContact: build.mutation({
            query: ({branchId, requestBody}) => {

                return {
                    url: `/ajax/createBranchContact/${branchId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['contactByBranchId'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Branch Contact");
            },
        }),

        updateBranchContact: build.mutation({
            query: ({contactId,branchId, requestBody}) => {
                return {
                    url: `/ajax/updateBranchContact/${branchId}/${contactId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['branchContacts',"contactByBranchId"],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Branch Contact");
            },
        }),

        deleteBranchContactById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete/branch-contact-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['contactByBranchId'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Branch Contact");
            },
        }),
    })
})

export const {
    useCreateBranchContactMutation,
    useGetBranchContactByIdQuery,
    useUpdateBranchContactMutation,
    useBranchContactsQuery,
    useDeleteBranchContactByIdMutation,
    useLazyGetBranchByCustomerIdQuery,
    useGetBranchContactByContactIdQuery,
    useLazyGetBranchContactByContactIdQuery

} = branchContactApi